export const getDataLayerName = gtmId => {
    return `dataLayer-${gtmId}`.replace(/-/g, "");;
}
